import React, { useContext, useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { SearchType } from "../../../helpers";
import { UfficioMappaContainer } from '../../common';
import {
    ResearchContext,
    ResearchProvider
} from './ResearchContext';
import {
    DeveloperBar,
    ResearchFilters
} from './components';

const PageContent = (props) => {

    const location = useLocation();

    const {

        state,

        isLoadingComuneUffici,
        isLoadingComuneAltriUffici,
        isLoadingUffici,
        isLoadingUfficiDistretto,
        isLoadingUfficiTerritorio,
        isLoadingUfficiTipoUfficio,
        isLoadingUfficiLibera,

        setIsWidgetConfigurationPageOpen,

        resolveLatAndLongCoordinates,

        userLocation,
        setUserLocation,

        tipoUfficioFilter,

        handleCookieData,

        tableResultTitle,
        tableResultSubtitle,
        tableResultSubtitle2,
        advancedSearchActive,

        activeSearchType,

        handleWidgetSearchSubmit,

        isLoadingFilters,

        queryParamsSearch,
        setActiveSearchType

    } = useContext(ResearchContext)

    const {

        uffici,
        altriUffici,

        tipiUffici,
        tipiUfficiDistrettuali,

        tuttiTipiUffici

    } = state;

    const [filtriTipiUfficiEnabled, setFiltriTipiUfficiEnabled] = useState([]);
    const [filterTipiUffici, setFilterTipiUffici] = useState([]);

    const handleCodeSubmit = () => {
        setIsWidgetConfigurationPageOpen(true);
    }

    useEffect(() => {
        setFiltriTipiUfficiEnabled(tuttiTipiUffici.map(x => x.id));
        setFilterTipiUffici(tuttiTipiUffici);
    }, [tuttiTipiUffici]);

    useEffect(() => {
        if (activeSearchType == SearchType.Distretto) {
            setFiltriTipiUfficiEnabled(tipiUfficiDistrettuali.map(x => x.id));
            setFilterTipiUffici(tuttiTipiUffici.filter(x => tipiUfficiDistrettuali.map(y => y.id).includes(x.id)));
        }
        else {
            setFiltriTipiUfficiEnabled(tuttiTipiUffici.map(x => x.id));
            setFilterTipiUffici(tuttiTipiUffici);
        }
    }, [activeSearchType]);

    useEffect(() => {
        if (tipiUfficiDistrettuali && advancedSearchActive) {
            setFiltriTipiUfficiEnabled(tipiUfficiDistrettuali.map(x => x.id));
            setFilterTipiUffici(tipiUffici);
        }
        if (tipiUffici && !advancedSearchActive) {
            setFiltriTipiUfficiEnabled(tuttiTipiUffici.map(x => x.id));
            setFilterTipiUffici(tuttiTipiUffici);
        }
    }, [advancedSearchActive]);

    useEffect(() => {
        if (isLoadingFilters)
            return;

        const queryParams = new URLSearchParams(location.search);
        var comune = queryParams.get('comune');
        var distretto = queryParams.get('distretto');
        var circondario = queryParams.get('circondario');
        var provincia = queryParams.get('provincia');
        var regione = queryParams.get('regione');
        var tipoUfficio = queryParams.get('tipoUfficio');
        var testo = queryParams.get('testo');
        var uffici = queryParams.get('uffici');

        handleWidgetSearchSubmit(comune, regione, provincia, distretto, circondario, tipoUfficio, testo, uffici);

        if (comune || regione || provincia || distretto || circondario || tipoUfficio || testo || uffici)
            return;

        navigator.geolocation.getCurrentPosition((position) => {

            setUserLocation(position);
            setActiveSearchType(SearchType.Comune);
            // console.log("Latitude is :", position.coords.latitude);
            // console.log("Longitude is :", position.coords.longitude);

            resolveLatAndLongCoordinates(position.coords.latitude, position.coords.longitude);
        }, (err) => {
            // if (err.PERMISSION_DENIED) {
            //     console.log("Permission denied");
            //     console.log("Get data from cookies");
            //     handleCookieData();
            // }

        });
    }, [isLoadingFilters]);

    return (
        <>
            {!queryParamsSearch && <ResearchFilters />}
            <div style={{ height: queryParamsSearch ? "calc(100vh - 0px)" : "calc(100vh - 174px)", width: "calc(100% - 8px)" }}>
                <UfficioMappaContainer
                    handleCodeClick={handleCodeSubmit}
                    activeSearchType={activeSearchType}
                    isAdvancedResearch={activeSearchType == SearchType.Distretto}
                    title={tableResultTitle}
                    subtitle={tableResultSubtitle}
                    subtitle2={tableResultSubtitle2}
                    currentUserLocation={userLocation}
                    isWidgetMap={false}
                    ufficiListVisibilityDefault={true}
                    isFiltriUfficiVisible={activeSearchType != SearchType.TipoUfficio && !tipoUfficioFilter}
                    filtriUfficiDefault={false}
                    ufficiList={uffici ?? []}
                    altriUfficiList={altriUffici ?? []}
                    filtriTipiUffici={(activeSearchType == SearchType.Distretto ? tipiUfficiDistrettuali : tipiUffici) ?? []}
                    filtriTipiUfficiEnabled={activeSearchType == SearchType.TipoUfficio ? tipiUffici.map(x => x.id) : filtriTipiUfficiEnabled}
                    setFiltriTipiUfficiEnabled={setFiltriTipiUfficiEnabled}
                    isLoadingUffici={isLoadingUffici || isLoadingComuneAltriUffici || isLoadingComuneUffici || isLoadingUfficiDistretto || isLoadingUfficiTerritorio || isLoadingUfficiTipoUfficio || isLoadingUfficiLibera}
                    isLoadingAltriUffici={isLoadingComuneAltriUffici}
                    filterTipiUffici={filterTipiUffici}
                />
                {!queryParamsSearch && <DeveloperBar />}
            </div>
        </>
    );
}

export const ResearchPage = () => {

    return (
        <ResearchProvider>
            <PageContent />
        </ResearchProvider>
    );
}